import React from 'react'

const MarkedText = ({ flag, children, classes='' }) => {
  const flagClasses = flag ? 'bg-ds-green-100 text-ds-green-500' : 'bg-ds-rose-100 text-gray-700'
  return (
    <span className={`inline-block font-semibold text-xs py-1 px-3 rounded-ds-md ${flagClasses} ${classes}`}>
      {children}
    </span>
  )
}

export default MarkedText
